
import { defineComponent } from 'vue';
import { useVModel } from 'vue-composable';

export default defineComponent({
  name: 'SocialGraphLegend',
  props: {
    colorList: {
      type: Array as () => { key: number; label: string }[],
      required: true
    },
    nodeList: {
      type: Array as () => { key: number; label: string }[],
      required: true
    }
  },
  setup(props) {
    const colors = useVModel(props, 'colorList');
    const nodes = useVModel(props, 'nodeList');

    return {
      colors,
      nodes
    };
  },
  mounted() {
    const legendCollapses = document.getElementsByClassName('n-collapse-item__header-main');
    if (!legendCollapses || legendCollapses.length === 0) {
      return;
    }

    const legendCollapse = legendCollapses[0] as HTMLElement;

    legendCollapse.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        legendCollapse.click();
      }
    });
    legendCollapse.tabIndex = 0;
  }
});
